"use client";

import { useEffect, useState } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useTask } from "@/context/TaskContext";
import TaskProgressWidget from "./TaskProgressWidget";

export default function GlobalTaskWidget() {
    const pathname = usePathname();
    const router = useRouter();
    const { activeTaskOrderId, stopTracking } = useTask();
    const [shouldShow, setShouldShow] = useState(false);

    // Determine if widget should show
    useEffect(() => {
        if (!activeTaskOrderId) {
            setShouldShow(false);
            return;
        }

        // Hide widget on the task status page itself
        const isOnTaskPage = pathname === `/orders/${activeTaskOrderId}/task`;
        setShouldShow(!isOnTaskPage);
    }, [pathname, activeTaskOrderId]);

    if (!shouldShow || !activeTaskOrderId) {
        return null;
    }

    return (
        <TaskProgressWidget
            orderId={activeTaskOrderId}
            onExpand={() => router.push(`/orders/${activeTaskOrderId}/task`)}
            onShowConfig={() => {
                router.push(`/orders/${activeTaskOrderId}`);
            }}
            onClose={() => {
                stopTracking();
            }}
        />
    );
}
